import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import Modal from "../Modal";
import service from "../../service";
import InteractionCard from "../InteractionCard";

const InteractionList = ({ interactions }) => {
  const [interactionCardResult, setInteractionCardResult] = useState(null)
  const [subscription, setSubscription] = useState(null);
  const [typeformResponse, setTypeformResponse] = useState(null);
  const [customFormResponse, setCustomFormResponse] = useState(null);
  const flowTitle = interactionCardResult?.flowStage?.flow?.flowTitle || 'N/A'
  const flowStageTitle = interactionCardResult?.flowStage?.title || 'N/A'
  const flowStageType = interactionCardResult?.flowStage?.flowStageTypes?.name || 'N/A'
  const interactionCreatedAt = interactionCardResult?.createdAt ? DateTime.fromISO(interactionCardResult?.createdAt).toLocaleString(DateTime.DATETIME_MED) : 'N/A'

  const getSubscription = async () => {
    const sub = await service.getSubscriptionById(interactionCardResult?.responseDataBindings[0])
    setSubscription(sub)
  };

  const getTypeformAndResponse = async () => {
    const res = await service.getTypeformResponse(interactionCardResult?.responseDataBindings[0])
    const response = await res.json();
    setTypeformResponse(response);
  };

  const getCustomFormAndResponse = async (index) => {
    const res = await service.getCustomFormResponse(interactionCardResult?.responseDataBindings[index])
    const response = await res.json();
    setCustomFormResponse(response);
  }

  // REGISTRATION_COMPLETION DATA
  const subscriptionTierTitle = subscription?.subscriptionTier?.title || 'N/A'
  const subscriptionTierDescription = subscription?.subscriptionTier?.description || 'N/A'
  const subscriptionDuration = `${subscription?.subscriptionDuration} ${subscription?.subscriptionUnit}`
  const walletDuration = `${subscription?.walletDuration} ${subscription?.walletUnit}`
  const walletRollover = `${subscription?.walletRolloverDurationAmount} ${subscription?.walletRolloverDurationUnit}`
  const subscriptionRegistrationCode = subscription?.registrationCode?.code || 'N/A'
  const subscriptionReferral = subscription?.referralId || 'N/A'
  const subscriptionInitialPrice = subscription?.initialSubscriptionPrice || 'N/A'
  const subscriptionSubsequentPrice = subscription?.initialSubscriptionPrice || 'N/A'
  const walletInitialPrice = subscription?.initialWalletPrice || 'N/A'
  const walletSubsequentPrice = subscription?.subsequentWalletPrice || 'N/A'
  const subscriptionLastRenewal = subscription?.renewedAt ? DateTime.fromISO(subscription?.renewedAt)?.toLocaleString(DateTime.DATETIME_MED) : 'N/A'
  const subscriptionCancelledAt = subscription?.cancelledAt ? DateTime.fromISO(subscription?.cancelledAt)?.toLocaleString(DateTime.DATETIME_MED) : 'N/A'

  // TYPEFORM DATA
  const typeformQuestions = typeformResponse?.form?.fieldsJson || []
  const typeformAnswers = typeformResponse?.answers?.answersJson || []

  // CUSTOM_FORM DATA
  const customFormQuestions = customFormResponse?.answers?.answersJson || []

  useEffect(() => {
    if (flowStageType === 'REGISTRATION_COMPLETION') {
      getSubscription()
    }
    if (flowStageType === 'TYPEFORM' || flowStageType === 'APPLICATION_REVIEW') {
      getTypeformAndResponse()
    }
    if (flowStageType === 'CUSTOM_FORM') {
      getCustomFormAndResponse(0)
    } else if (flowStageType === 'APPLICATION_REVIEW') {
      getCustomFormAndResponse(1)
    }
  }, [interactionCardResult])

  return (
    <div className='flex flex-col gap-4'>
      {!!interactions?.length && interactions?.map((result, i) => {
        return (
          <InteractionCard
            key={`interaction-${i}-${result.id}`}
            result={result}
            setInteractionCardResult={setInteractionCardResult}
            i={i}
          />
        )
      })}

      <Modal className={"min-h-[50%] max-w-xl dark:bg-zinc-900 dark:text-zinc-100"}>
        {flowStageType === "APPLICATION_REVIEW" && (
          <div className="flex flex-col gap-4 bg-aoh-surface dark:bg-zinc-800 p-4 rounded">
            <div className="flex w-full">
              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Flow:</span>
                  <span className=''>{flowTitle}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Stage:</span>
                  <span className=''>{flowStageTitle}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Type:</span>
                  <span className=''>{flowStageType}</span>
                </div>
              </div>

              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Time:</span>
                  <span className=''>{interactionCreatedAt}</span>
                </div>
              </div>
            </div>

            <div className='pt-4 font-semibold'>
              <span>Application</span>
            </div>

            {typeformQuestions?.map((q) => {
              let nestedQuestions;
              if (q?.properties?.fields?.length) {
                nestedQuestions = q?.properties?.fields.map((subQ) => {
                  const subAnswer = typeformAnswers.find((a) => a.fieldId === subQ.id) || 'N/A'

                  return (
                    <div key={`q-sub${subQ.id}`} className='bg-white dark:bg-zinc-900 p-2 rounded'>
                      <div className='flex gap-2 text-sm'>
                        <span className='font-bold'>Question:</span>
                        <span className=''>{subQ.title}</span>
                      </div>

                      <div className='flex gap-2 text-sm'>
                        <span className='font-bold'>Answer:</span>
                        <span className=''>{subAnswer[subAnswer.type]}</span>
                      </div>
                    </div>
                  )
                })
              }

              const answer = typeformAnswers.find((a) => a.fieldId === q.id) || 'N/A'

              return nestedQuestions ? nestedQuestions : (
                <div key={`q-${q.id}`} className='bg-white dark:bg-zinc-900 p-2 rounded'>
                  <div className='flex gap-2 text-sm'>
                    <span className='font-bold'>Question:</span>
                    <span className=''>{q.title}</span>
                  </div>

                  <div className='flex gap-2 text-sm'>
                    <span className='font-bold'>Answer:</span>
                    <span className=''>{answer[answer.type !== 'phone_number' ? answer.type : 'phoneNumber']}</span>
                  </div>
                </div>
              )
            })}

            <div className='pt-4 font-semibold'>
              <span>Review</span>
            </div>

            {customFormQuestions?.map((q, i) => {
              const question = Object.keys(q)
              const answer = q[question]
              return (
                <div key={`q-${i}`} className='bg-white dark:bg-zinc-900 p-2 rounded'>
                  <div className='flex gap-2 text-sm'>
                    <span className='font-bold'>Question:</span>
                    <span className=''>{question[0]}</span>
                  </div>

                  <div className='flex gap-2 text-sm'>
                    <span className='font-bold'>Answer:</span>
                    <span className=''>{answer}</span>
                  </div>
                </div>
              )
            })}


          </div>
        )}

        {flowStageType === "REGISTRATION_COMPLETION" && (
          <div className='flex flex-col gap-4 bg-aoh-surface dark:bg-zinc-800 p-4 rounded'>
            <div className="flex w-full bg-white dark:bg-zinc-900 p-2 rounded">
              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Flow:</span>
                  <span className=''>{flowTitle}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Stage:</span>
                  <span className=''>{flowStageTitle}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Type:</span>
                  <span className=''>{flowStageType}</span>
                </div>
              </div>

              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Time:</span>
                  <span className=''>{interactionCreatedAt}</span>
                </div>
              </div>
            </div>

            {/* Subscription Title / Description */}
            <div className="flex flex-col w-full bg-white dark:bg-zinc-900 p-2 rounded">
              <div className='flex gap-2 text-sm'>
                <span className='font-bold'>Subscription Tier:</span>
                <span className=''>{subscriptionTierTitle}</span>
              </div>

              <div className='flex gap-2 text-sm'>
                <span className='font-bold'>Tier Description:</span>
                <span className=''>{subscriptionTierDescription}</span>
              </div>
            </div>

            {/* Subscription Registration Code / Referral */}
            <div className="flex flex-col w-full bg-white dark:bg-zinc-900 p-2 rounded">
              <div className='flex gap-2 text-sm'>
                <span className='font-bold'>Registration Code:</span>
                <span className=''>{subscriptionRegistrationCode}</span>
              </div>

              <div className='flex gap-2 text-sm'>
                <span className='font-bold'>Referral:</span>
                <span className=''>{subscriptionReferral}</span>
              </div>
            </div>

            {/* Subscription Price / Duration */}
            <div className="flex w-full bg-white dark:bg-zinc-900 p-2 rounded">
              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Initial Subscription Price:</span>
                  <span className=''>{subscriptionInitialPrice}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Subsequent Subscription Price:</span>
                  <span className=''>{subscriptionSubsequentPrice}</span>
                </div>
              </div>

              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Subscription Duration:</span>
                  <span className=''>{subscriptionDuration}</span>
                </div>
              </div>
            </div>

            {/* Wallet Price / Duration */}
            <div className="flex w-full  bg-white dark:bg-zinc-900 p-2 rounded">
              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Initial Wallet Price:</span>
                  <span className=''>{walletInitialPrice}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Subsequent Wallet Price:</span>
                  <span className=''>{walletSubsequentPrice}</span>
                </div>
              </div>

              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Wallet Duration:</span>
                  <span className=''>{walletDuration}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Wallet Rollover:</span>
                  <span className=''>{walletRollover}</span>
                </div>
              </div>
            </div>

            {/* Subscription RenewedAt / CancelledAt */}
            <div className="flex flex-col w-full bg-white dark:bg-zinc-900 p-2 rounded">
              <div className='flex gap-2 text-sm'>
                <span className='font-bold'>Last Renewed At:</span>
                <span className=''>{subscriptionLastRenewal}</span>
              </div>

              <div className='flex gap-2 text-sm'>
                <span className='font-bold'>Cancelled At:</span>
                <span className=''>{subscriptionCancelledAt}</span>
              </div>
            </div>
          </div>
        )}

        {flowStageType === "TYPEFORM" && (
          <div className="flex flex-col gap-4 bg-aoh-surface dark:bg-zinc-800 p-4 rounded">
            <div className="flex w-full bg-white dark:bg-zinc-900 p-2 rounded">
              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Flow:</span>
                  <span className=''>{flowTitle}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Stage:</span>
                  <span className=''>{flowStageTitle}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Type:</span>
                  <span className=''>{flowStageType}</span>
                </div>
              </div>

              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Time:</span>
                  <span className=''>{interactionCreatedAt}</span>
                </div>
              </div>
            </div>

            <div className='pt-4 font-semibold'>
              <span>Application</span>
            </div>

            {typeformQuestions?.map((q) => {
              let nestedQuestions;
              if (q?.properties?.fields?.length) {
                nestedQuestions = q?.properties?.fields.map((subQ) => {
                  const subAnswer = typeformAnswers.find((a) => a.fieldId === subQ.id) || 'N/A'

                  return (
                    <div key={`q-sub${subQ.id}`} className='bg-white dark:bg-zinc-900 p-2 rounded'>
                      <div className='flex gap-2 text-sm'>
                        <span className='font-bold'>Question:</span>
                        <span className=''>{subQ.title}</span>
                      </div>

                      <div className='flex gap-2 text-sm'>
                        <span className='font-bold'>Answer:</span>
                        <span className=''>{subAnswer[subAnswer.type]}</span>
                      </div>
                    </div>
                  )
                })
              }

              const answer = typeformAnswers.find((a) => a.fieldId === q.id) || 'N/A'

              return nestedQuestions ? nestedQuestions : (
                <div key={`q-${q.id}`} className='bg-white dark:bg-zinc-900 p-2 rounded'>
                  <div className='flex gap-2 text-sm'>
                    <span className='font-bold'>Question:</span>
                    <span className=''>{q.title}</span>
                  </div>

                  <div className='flex gap-2 text-sm'>
                    <span className='font-bold'>Answer:</span>
                    <span className=''>{answer[answer.type !== 'phone_number' ? answer.type : 'phoneNumber']}</span>
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {flowStageType === "CUSTOM_FORM" && (
          <div className="flex flex-col gap-4 bg-aoh-surface dark:bg-zinc-800 p-4 rounded">
            <div className="flex w-full">
              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Flow:</span>
                  <span className=''>{flowTitle}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Stage:</span>
                  <span className=''>{flowStageTitle}</span>
                </div>

                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Type:</span>
                  <span className=''>{flowStageType}</span>
                </div>
              </div>

              <div className='flex-col w-1/2'>
                <div className='flex gap-2 text-sm'>
                  <span className='font-bold'>Time:</span>
                  <span className=''>{interactionCreatedAt}</span>
                </div>
              </div>
            </div>

            {customFormQuestions?.map((q, i) => {
              const question = Object.keys(q)
              const answer = q[question]
              return (
                <div key={`q-${i}`} className='bg-white dark:bg-zinc-900 p-2 rounded'>
                  <div className='flex gap-2 text-sm'>
                    <span className='font-bold'>Question:</span>
                    <span className=''>{question[0]}</span>
                  </div>

                  <div className='flex gap-2 text-sm'>
                    <span className='font-bold'>Answer:</span>
                    <span className=''>{answer}</span>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </Modal>
    </div>

  );
};

export default InteractionList;
